export default "/fonts/SegoeUI.woff2?40b6acea10e827613ee2282cd83c0912";